import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import Sidebar from '../componenteExtra/SidebarSolicitante'; // Ajusta la ruta según tu estructura de proyecto
import { FaFileSignature, FaClock } from 'react-icons/fa';
import imagen1 from '../img/get_view1.jpg';
import Footer from '../componenteExtra/Footer';
import SessionManager from '../componenteExtra/SessionManager';
import NotificationBell from '../notificaciones/NotificationBell';

const MenuSolicitante = () => {
  const navigate = useNavigate();
  const [nombre_get, setNombreGet] = useState('');

  useEffect(() => {
    // Obtener el nombre_get y rol desde el localStorage
    const storedNombreGet = localStorage.getItem('nombre_get');
    setNombreGet(storedNombreGet);
  }, []);

  return (
    <div className="app">
      <SessionManager />
      <div className="main-content">
        <Sidebar />
        <div className="main-panel">
          <div className="welcome-message">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "20px 0",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <h2 style={{ margin: 0, lineHeight: 1 }}>
                Bienvenido(a) Solicitante GET - {nombre_get}
              </h2>
              {nombre_get && <NotificationBell />}
            </div>
            <img src={imagen1} alt="Decorative" style={{ width: '100%', height: 'auto' }} />
          </div>
          <div className="cards-container">
            <div className="card">
              <div className="card-header">
                <FaFileSignature />
                <h3>Nueva solicitud servicio GET</h3>
              </div>
              <div className="card-subtitle">Acceso directo</div>
              <div className="card-content">
                En este módulo puedes hacer la solicitud de las actividades a realizar por el área GET
              </div>
              <button onClick={() => navigate('/SolicitarServicioGET')}>Ir a Nueva Solicitud</button>
            </div>
            <div className="card">
              <div className="card-header">
                <FaClock />
                <h3>Solicitudes actuales en espera de documentación</h3>
              </div>
              <div className="card-subtitle">Acceso directo</div>
              <div className="card-content">
                En este módulo encontraras las actividades que se solicitaron para la documentación
              </div>
              <button onClick={() => navigate('/EsperaDocumentos')}>Ir a agregar documentación</button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MenuSolicitante;
